export { openAndWaitForCallback } from './lib/browser';
export { getPlatform, isAndroid, isCapacitor, isIOS } from './lib/platform';
export type { Platform } from './lib/platform';
export { capacitorStorage, getPlatformStorage, noopStorage, webStorage } from './lib/platform-storage';
export type { PlatformStorage } from './lib/platform-storage';
